'use client';
import { Features, useFeatureOverrides } from '@finn/ua-featureflags';
import React from 'react';

export const ProductDetailsB = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  useFeatureOverrides(Features.ExpPlpAdvancedGrouping, 'b');

  return children;
};

export const ProductDetailsA = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  useFeatureOverrides(Features.ExpPlpAdvancedGrouping, 'a');

  return children;
};
